import CenterContents from "../component/CenterContents"
import Accordion from "../component/Accordion" // or wherever your Accordion is
import InstructionComponent from "../component/instruction/InstructionComponent"
import SmallestHeadingComponent from "../component/SmallestHeadingComponent"

import AppDownloadInstructions from "../component/instruction/patient/AppDownloadInstructions"
import OuraSetupInstructions from "../component/instruction/patient/OuraSetupInstructions"
import AppLoginInstructions from "../component/instruction/patient/AppLoginInstructions"
import OuraConnectInstructions from "../component/instruction/patient/OuraConnectInstructions"

import CakeIcon from "../icon/CakeIcon"
import OuraSetupInstructionPart1 from "../component/instruction/patient/OuraSetupInstructionPart1"
import OuraSetupInstructionPart2 from "../component/instruction/patient/OuraSetupInstructionPart2"

function PatientHelpTutorialView() {
  return (
    <CenterContents>
      <div className="w-full max-w-[1000px] m-5 flex flex-col space-y-8">

        {/* Accordion for the first two InstructionComponents */}
        <Accordion title="Teil 1: Erste Schritte (Vor dem Praxisbesuch)">
          <div className="flex flex-col space-y-8">
            <InstructionComponent {...AppDownloadInstructions} />
            <InstructionComponent {...OuraSetupInstructionPart1} />
            <div className="text-center text-2xl font-semibold">
              Sie haben nun den ersten Teil der Einrichtung erfolgreich
              abgeschlossen. Es sollten sich zu diesem Zeitpunkt zwei Apps auf
              Ihrem Smartphone befinden: Die Oura App und die DOOR Studie
              Connect App. Den 2. Teil der Einrichtung können Sie beim
              Praxisbesuch durchführen.
            </div>

          </div>
        </Accordion>
        
        {/* Accordion for the next two InstructionComponents */}
        <Accordion title="Teil 2: Weitere Konfigurationen (Beim Praxisbesuch)">
          <div className="flex flex-col space-y-8">
          <InstructionComponent {...OuraSetupInstructionPart2} />
            <InstructionComponent {...AppLoginInstructions} />
            <InstructionComponent {...OuraConnectInstructions} />
          </div>
        </Accordion>

        {/* Final Confirmation */}
        <div className="w-full flex flex-col space-y-2 py-10 items-center justify-center">
          <CakeIcon />
          <div>Sie haben das Tutorial erfolgreich abgeschlossen</div>
        </div>
      </div>
    </CenterContents>
  )
}

export default PatientHelpTutorialView
